/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：632
 */

var r = require(/* 1234 */"../1648/1234/index")
var o = require(/* 757 */"../1648/757")
module.exports = function (e) {
  var t = r(e, "string")
  return o(t) ? t : String(t)
}
